import React, { useEffect, useState } from 'react';
import { post } from '../../Auths/AuthToken';
import { useSelector } from 'react-redux';
import setUiMessage from '../../../Utilities/Tostify';

function AddEditReferralProviderPopup({
  onClose,
  onReload,
  editPopup,
  setEditPopup,
}) {
  const { user } = useSelector((store) => store.auth);

  const [data, setData] = useState('');
  const [formData, setFormData] = useState({
    id: '',
    doctor_first_name: '',
    doctor_last_name: '',
    qualification: '',
    clinic_name: '',
    speciality: '',
    npi_no: '',
    address_1: '',
    city: '',
    state: '',
    zip: '',
    email: '',
    phone_l: '',
    phone_m: '',
    fax: '',
    description: '',
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/commonTask/openAddEditRefMasterPopup',
          {
            refProviderId: editPopup?.referringMasterId,
            popUpType: 'refProvider',
          }
        );
        if (response.status === 200) {
          setData(response.data);
          setFormData({
            id: response.data.refProviderMaster[0]?.id || '',
            doctor_first_name:
              response.data.refProviderMaster[0]?.doctor_first_name || '',
            doctor_last_name:
              response.data.refProviderMaster[0]?.doctor_last_name || '',
            qualification:
              response.data.refProviderMaster[0]?.qualification || '',
            clinic_name: response.data.refProviderMaster[0]?.clinic_name || '',
            speciality: response.data.refProviderMaster[0]?.speciality || '',
            npi_no: response.data.refProviderMaster[0]?.npi_no || '',
            address_1: response.data.refProviderMaster[0]?.address_1 || '',
            city: response.data.refProviderMaster[0]?.city || '',
            state: response.data.refProviderMaster[0]?.state || '',
            zip: response.data.refProviderMaster[0]?.zip || '',
            email: response.data.refProviderMaster[0]?.email || '',
            phone_l: response.data.refProviderMaster[0]?.phone_l || '',
            phone_m: response.data.refProviderMaster[0]?.phone_m || '',
            fax: response.data.refProviderMaster[0]?.fax || '',
            description: response.data.refProviderMaster[0]?.description || '',
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [editPopup]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const onSaveUpdate = async () => {
    try {
      if (
        !formData?.doctor_first_name &&
        !formData?.doctor_last_name &&
        !formData?.clinic_name
      ) {
        setUiMessage(
          'err',
          'Please enter atleast one: First Name, Last Name or Clinic Name '
        );
      } else if (!formData?.address_1) {
        setUiMessage('err', 'Please enter Address');
      } else if (!formData?.city) {
        setUiMessage('err', 'Please enter City');
      } else if (!formData?.state) {
        setUiMessage('err', 'Please enter State');
      } else if (!formData?.zip) {
        setUiMessage('err', 'Please enter Zip');
      } else if (!formData?.email) {
        setUiMessage('err', 'Please enter Email');
      } else if (!formData?.phone_l) {
        setUiMessage('err', 'Please enter Desk Phone');
      } else if (!formData?.fax) {
        setUiMessage('err', 'Please enter Fax');
      } else {
        const response = await post('api/commonTask/saveUpdateRefMaster', {
          userId: user?.id,
          refProviderId: editPopup?.referringMasterId || '',
          ...formData,
        });
        if (response.status === 200) {
          setUiMessage('suc', 'Successfully added New Provider/Clinic.');
          onReload();
          onClose();
        }
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="openReferringProviderPopup">
        {/* HEADER */}
        <div className="addressBookHeader">
          <span className="addressTitle">
            <h2>Update Provider/Clinic</h2>
          </span>
          <span className="addressClose" onClick={onClose}>
            X
          </span>
        </div>

        {/* BODY */}
        <div className="addressBody">
          {/* FIRST ROW */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">First Name</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="doctor_first_name"
                  value={formData.doctor_first_name}
                  placeholder="Provider first name"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Last Name</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="doctor_last_name"
                  value={formData.doctor_last_name}
                  placeholder="Provider last name"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Degree/Credentials</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="qualification"
                  value={formData.qualification}
                  placeholder="MD, DO, NP etc"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* CLINIC NAME */}
          <div className="addressBodyRow">Clinic Name</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="clinic_name"
              value={formData.clinic_name}
              placeholder="Clinic or facility name"
              onChange={handleChange}
            />
          </div>

          {/* SPECIALTY & NPI */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Specialty</div>
              <div className="addressBodyRow">
                <select
                  id="refSpecialty"
                  name="speciality"
                  className="chzn-select addressBookSearh"
                  style={{ height: '40px' }}
                  value={formData.speciality}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.specialityMaster?.map((sp) => (
                    <option key={sp.id} value={sp.id}>
                      {sp.speciality}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">NPI Number</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="npi_no"
                  value={formData.npi_no}
                  placeholder="Provider NPI"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* ADDRESS 1 */}
          <div className="addressBodyRow">Street Address *</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="address_1"
              value={formData.address_1}
              placeholder="Street Address"
              onChange={handleChange}
            />
          </div>

          {/* CITY, STATE, ZIP */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">City *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="city"
                  value={formData.city}
                  placeholder="City"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">State *</div>
              <div className="addressBodyRow">
                <select
                  id="refState"
                  name="state"
                  className="chzn-select addressBookSearh"
                  style={{ height: '40px' }}
                  value={formData.state}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.stateMaster?.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.stateName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">ZIP Code *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="zip"
                  value={formData.zip}
                  placeholder="Zip"
                  maxLength="5"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* EMAIL */}
          <div className="addressBodyRow">Email *</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="email"
              value={formData.email}
              placeholder="Email address"
              onChange={handleChange}
            />
          </div>

          {/* PHONE NUMBERS */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Desk Phone *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="phone_l"
                  value={formData.phone_l}
                  placeholder="Main phone number"
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Cell Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="phone_m"
                  value={formData.phone_m}
                  placeholder="Mobile number"
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Fax *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="fax"
                  value={formData.fax}
                  placeholder="Fax number"
                  maxLength="10"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          {/* NOTE */}
          <div className="addressBodyRow">Note</div>
          <div className="addressBodyRow">
            <textarea
              className="addressBookSearh"
              name="description"
              rows="3"
              placeholder="Additional notes or special instructions"
              value={formData.description}
              onChange={handleChange}
            ></textarea>
          </div>

          {/* BUTTONS */}
          <div className="addressBodyRow">
            <div
              style={{ marginLeft: '10px' }}
              className="button-submit right"
              onClick={() => {
                // onUpdate(formData.id, formData)
                onSaveUpdate();
              }}
            >
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </div>

            <div className="button-submit right" onClick={onClose}>
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEditReferralProviderPopup;
